import { LoadingOverlay } from '@mantine/core';
import { ManipulateType } from 'dayjs';
import React, { useMemo, useState } from 'react';

import { useDeviceStatusHistory } from '@portals/api/organizations';
import {
  DeviceStatusIncidentTimelineWidget,
  DeviceStatusIncidentTimelineWidgetFormType,
  TIMELINE_RANGE_OPTIONS,
  TimelineRangeNamesType,
} from '@portals/device-widgets';

import { WidgetProps } from '../device-widgets.types';

export function DeviceStatusIncidentTimelineWrapper({
  deviceId,
  widget,
}: WidgetProps<DeviceStatusIncidentTimelineWidgetFormType>) {
  const [selectedTimeRange, setSelectedTimeRange] =
    useState<TimelineRangeNamesType>(TIMELINE_RANGE_OPTIONS.oneHour);

  const fields = widget?.config?.fields;
  const name = fields?.name ?? '';

  const { timeUnit, timeRange } = useMemo<{
    timeUnit: ManipulateType;
    timeRange: number;
  }>(() => {
    switch (selectedTimeRange) {
      case TIMELINE_RANGE_OPTIONS.oneDay:
        return { timeUnit: 'day', timeRange: 1 };
      case TIMELINE_RANGE_OPTIONS.sevenDays:
        return { timeUnit: 'day', timeRange: 7 };
      case TIMELINE_RANGE_OPTIONS.sixHours:
        return { timeUnit: 'hour', timeRange: 6 };
      default:
        return { timeUnit: 'hour', timeRange: 1 };
    }
  }, [selectedTimeRange]);

  const deviceStateHistory = useDeviceStatusHistory({
    deviceId,
    timeUnit,
    timeRange,
  });

  if (deviceStateHistory.isLoading) {
    return <LoadingOverlay visible />;
  }

  const onSetSelectedTimes = (time: TimelineRangeNamesType) => {
    setSelectedTimeRange(TIMELINE_RANGE_OPTIONS[time]);
  };

  return (
    <DeviceStatusIncidentTimelineWidget
      name={name}
      deviceStateHistory={deviceStateHistory.data}
      onChangeSelectedTimeRange={onSetSelectedTimes}
      selectedTimeRange={TIMELINE_RANGE_OPTIONS[selectedTimeRange]}
    />
  );
}
